import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";
import Router from "./router";
import AuthDataProvider from "./utils/storages/authDataProvider";
import { SnackbarProvider } from "notistack";
import { QueryCache, QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material";
import theme from "./styles/theme";
import RTL from "./styles/rtl/RTL";
import "./styles/font.css";

const validRoutes = (route) => {
  switch (route) {
    case "login":
    case "signup":
      return false;
    default:
      return true;
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (error?.response?.status === 401 && validRoutes() && process.env.REACT_APP_ENV !== "demo") {
        localStorage.removeItem("user");
        localStorage.removeItem("bulk");
        setTimeout(() => {
          window?.location?.replace("/");
        }, 1000);
      }
    },
  }),
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeProvider theme={theme}>
    <RTL>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <SnackbarProvider autoHideDuration={1000}>
            <AuthDataProvider>
              <Router />
            </AuthDataProvider>
          </SnackbarProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </RTL>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
